// client/src/hooks/useSessionState.js
import { useCallback, useRef } from 'react';
import { useSyncExternalStore } from 'react';
import {
  getSessionValue,
  setSessionValue,
  subscribeSession,
  getSessionRef,
  DRAFT_KEY,
} from '../store/chatSessionStore';

export function useSessionState(chatId, field, initialValue) {
  const key = chatId || DRAFT_KEY;
  const initRef = useRef(initialValue);

  const subscribe = useCallback((onChange) => subscribeSession(key, onChange), [key]);
  const getSnapshot = useCallback(
    () => getSessionValue(key, field, initRef.current),
    [key, field]
  );

  const value = useSyncExternalStore(subscribe, getSnapshot);

  const setValue = useCallback(
    (updater) => setSessionValue(key, field, updater),
    [key, field]
  );

  return [value, setValue];
}

export function useSessionRef(chatId, field, initialValue) {
  const key = chatId || DRAFT_KEY;
  return getSessionRef(key, field, initialValue);
}